module.exports = __webpack_public_path__ + "static/img/jifenshangcheng.e433b6c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/type/daohang/jifenshangcheng.png
// module id = Val2
// module chunks = 12